import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip, Typography, Button } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ProductChips from '@/components/ProductChips';

const ProductBasicInfo = ({ product , textAlign}) => {

  const producer = product?.producer;
  const awards = product?.awards
    ? product.awards.map((award, i) => (
      <Box key={i}>
        <Chip
          color="primary"
          sx={{ margin: '5px 0px 0px 0px ' }}
          icon={<EmojiEventsIcon />}
          label={award.displayText}
        />
      </Box>
    ))
    : [];
  const features = <ProductChips producer={producer} product={product} />;
  return (
    <>
      <Box sx={{ padding: '10px 15px 0px 0px' }}>
        <Typography variant="subtitle2" textAlign={textAlign}>
          {[
            product.type,
            product.grape,
            product.vintage,
            product.alcohol && `${product.alcohol}%`,
            product.unitMeasure,
          ]
            .filter((v) => v)
            .join(' | ')}
        </Typography>

        {product?.sku ? (
          <Typography variant="subtitle2">{`sku: ${product.sku}`}</Typography>
        ) : null}
      </Box>

      {product.soldOut && (
        <Button
          variant="outlined"
          disabled
          fullWidth
          sx={{
            color: 'red !important',
            fontWeight: 600,
            border: '1px solid red !important',
            margin: '15px',
          }}
        >
          Sold Out
        </Button>
      )}

      {awards && (
        <Box display="flex" flexDirection={'row'} gap={1} flexWrap={'wrap'}>
          {awards}
        </Box>
      )}

      {features && (
        <Box
          sx={{ padding: '5px 15px 5px 0px' }}
          display="flex"
          flexDirection={'row'}
          gap={1}
          flexWrap={'wrap'}
        >
          {features}
        </Box>
      )}
    </>
  )
};

ProductBasicInfo.propTypes = {
  product: PropTypes.object.isRequired,
  textAlign: PropTypes.string,
};

export default ProductBasicInfo;
